export const isLikelyInAppBrowser = () =>
  /FBAN|FBAV|Instagram|Line\/|MicroMessenger|Snapchat|GSA\/|; wv\)/i.test(navigator.userAgent);

export const isTouchDevice = () => navigator.maxTouchPoints > 0 || 'ontouchstart' in window;
